export default __webpack_public_path__ + "static/media/certifi-3.34f09786.png";